<template>
  <div class="enquiry-form">
    <div class="container">
      <header class="enquiry-form__header">
        <span class="enquiry-form__icon">
          <i
            :class="icon || 'fal fa-user-headset'"
            role="presentation"
            aria-label="">
          </i>
        </span>

        <h3 class="enquiry-form__heading">
          {{ heading || "Can we help any further?" }}
        </h3>

        <button
          id="enquiry-form-toggle"
          class="btn btn-accent-1 enquiry-form__toggle"
          aria-controls="enquiry-form-body"
          :aria-expanded="open"
          @click="open = !open">
          <span>
            <template v-if="open">
              Close
            </template>
            <template v-else>
              {{ label || "Get in touch" }}
            </template>
          </span>

          <font-awesome-icon
            :icon="['fas', 'chevron-up']"
            :rotation="open ? undefined : 180"
            role="presentation"
            aria-label="">
          </font-awesome-icon>
        </button>
      </header>

      <div
        v-show="open"
        id="enquiry-form-body"
        class="enquiry-form__main"
        aria-labelledby="enquiry-form-toggle">
        <iframe
          v-if="open"
          v-resize
          :src="src"
          class="enquiry-form__embed"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EnquiryForm",
  props: {
    src: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: null,
    },
    heading: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
  },
  data: () => ( {
    open: false,
  } ),
};
</script>

<style lang="less" scoped>
@import "../Styles/utils/colors.less";

.enquiry-form {
  background: #f0ece6;

  &__header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px 0;

    @media ( max-width: 500px ) {
      flex-wrap: wrap;
    }
  }

  &__icon {
    font-size: 24px;
    color: @color-accent-1;
    display: inline-block;
    margin-right: 15px;

    @media ( max-width: 500px ) {
      margin: 15px 30px;
      font-size: 32px;
    }
  }

  &__heading {
    margin: 0;
    font-size: 1.45rem;
  }

  &__toggle {
    margin-left: 30px;
    min-width: 137px;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;

    span {
      flex-grow: 1;
    }

    svg {
      display: inline-block;
      margin-left: 10px;
    }

    @media ( max-width: 500px ) {
      margin-left: 0;
      margin-top: 15px;
    }
  }

  &__main {
    padding-bottom: 30px;
  }

  &__embed {
    width: 100%;
    height: 500px;
    border: 1px solid transparent;
  }
}
</style>
